// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","631":"contact","824":"portfolio"}[chunkId] + "." + {"443":"5bf40a3d","631":"9cc826bc","824":"e86fb1de"}[chunkId] + ".js";
};